/* Zlatarstvo Gajsek - samodejno zapiranje mobilnega menija ob drsenju
 *
 * ZELJA: ko je na telefonu odprt meni in uporabnik podrsa navzdol,
 * naj se meni sam zapre.
 *
 * KAKO:
 * - Odprtost menija prepoznamo po Dawnovem razredu 'menu-opening' na <details>.
 * - Za zapiranje klicemo Dawnovo lastno metodo closeMenuDrawer(), da se
 *   pravilno pocisti vse: razred 'menu-opening', 'overflow-hidden-tablet'
 *   na <body>, aria atributi in fokus. (Rocno nastavljanje details.open = false
 *   bi pustilo <body> zaklenjen in meni v pol-odprtem stanju.)
 * - Reagiramo SAMO na drsenje strani (window scroll). Drsenje ZNOTRAJ menija
 *   ne sprozi window scroll dogodka, zato dolg meni ostane uporaben.
 * - Prag 40px prepreci, da bi meni zaprl ze najmanjsi premik prsta.
 *
 * Opomba: Dawn ob odprtju zaklene drsenje strani (overflow-hidden-tablet),
 * a iOS Safari tega ne upsteva zanesljivo - stran se vseeno premakne,
 * zato je ta skripta potrebna.
 */
(function () {
  function setup() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    var details = headerDrawer.querySelector('details');
    var summary = details ? details.querySelector('summary') : null;
    if (!details || !summary) return;

    var THRESHOLD = 40;
    var scrollYWhenOpened = null;

    function isOpen() {
      return details.classList.contains('menu-opening');
    }

    /* Zapomni si polozaj strani v trenutku, ko se meni odpre. */
    new MutationObserver(function () {
      scrollYWhenOpened = isOpen() ? window.scrollY : null;
    }).observe(details, { attributes: true, attributeFilter: ['class'] });

    window.addEventListener(
      'scroll',
      function () {
        if (!isOpen()) return;

        if (scrollYWhenOpened === null) {
          scrollYWhenOpened = window.scrollY;
          return;
        }

        if (Math.abs(window.scrollY - scrollYWhenOpened) > THRESHOLD) {
          scrollYWhenOpened = null;

          if (typeof headerDrawer.closeMenuDrawer === 'function') {
            headerDrawer.closeMenuDrawer(null, summary);
          } else {
            details.classList.remove('menu-opening');
            details.removeAttribute('open');
            document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
          }
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
